import { z } from "zod";

// Базовые схемы для переиспользования
const emailSchema = z
  .string()
  .min(1, "Email обязателен")
  .email("Введите корректный email");

const passwordSchema = z
  .string()
  .min(6, "Пароль должен содержать минимум 6 символов")
  .max(100, "Пароль не может быть длиннее 100 символов");

// Схема для формы логина
export const loginSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
});

// Схема для формы регистрации
export const registerSchema = z
  .object({
    email: emailSchema,
    password: passwordSchema,
    confirmPassword: z.string().min(1, "Подтверждение пароля обязательно"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Пароли не совпадают",
    path: ["confirmPassword"],
  });

// Типы для TypeScript
export type LoginFormData = z.infer<typeof loginSchema>;
export type RegisterFormData = z.infer<typeof registerSchema>;
